enum AssetType {
  Office = 'Office Space',
  Retail = 'Retail',
  Warehouse = 'Warehouse',
  Other = 'Other',
}

export default AssetType;
